// =============================================
// CURSOR — Custom lime dot cursor
// =============================================

(function () {
  var cur = document.getElementById('cursor');
  if (!cur) return;

  document.addEventListener('mousemove', function (e) {
    cur.style.left = e.clientX + 'px';
    cur.style.top  = e.clientY + 'px';
  });

  var interactives = document.querySelectorAll(
    'a, button, input, textarea, select, .pcard, .tstep, .team-card, label'
  );

  interactives.forEach(function (el) {
    el.addEventListener('mouseenter', function () { cur.classList.add('big'); });
    el.addEventListener('mouseleave', function () { cur.classList.remove('big'); });
  });
})();
